import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackCheckbox from "../Input/FeedbackCheckBox";
import FeedbackText from "../Input/FeedbackText";
import { ErrorMessage } from "./ErrorMessage";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question2CoachingMethodology = ({
  coachingMethodologyRatingFactors,
  coachingMethodologyFeedback,
  updateSelectionFormData,
  updateFormData,
  onEnterKeyPress,
  validationError,
}) => {

  return (
    <>
      <FeedbackFormLayout
        title={"Experience with the coaching methodology"}
        subtitle={
          "Tell us more about if and how the coaching steps and structure help you."
        }
      >
        <FeedbackHeader
          title={
            "Can you elaborate on what specifically contributed to your rating?*"
          }
        />
        <FeedbackCheckbox
          inputID={"coachingMethodologyRatingFactors"}
          checkBoxList={coachingMethodologyRatingFactors}
          updateSelectionFormData={updateSelectionFormData}
        />
        <FeedbackText
          inputID={"coachingMethodologyFeedback"}
          inputText={coachingMethodologyFeedback}
          updateFormData={updateFormData}
          onEnterKeyPress={onEnterKeyPress}
          placeHolder={"Share more about your selection(s) above here"}
        />
        {validationError?.error && (<ErrorMessage text={validationError.error} />)}

      </FeedbackFormLayout>
    </>
  );
};
